import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errorMessage } from "@/lib/api";

const FIELDS = [["name", "Seu nome", true], ["company", "Empresa", false], ["phone", "WhatsApp / telefone", true], ["city", "Cidade", false]];
const blank = { name: "", company: "", phone: "", city: "", message: "" };

export const LeadForm = () => {
  const [f, setF] = useState(blank);
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    setError("");
    try {
      await api.post("/public/leads", f);
      setState("sent");
      setF(blank);
    } catch (err) {
      setError(errorMessage(err));
      setState("idle");
    }
  };

  return (
    <section id="contato" className="mx-auto grid max-w-6xl gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2">
      <div>
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Quer ver o Ciclo Certo na sua empresa?</h2>
        <p className="mt-4 text-slate-400">Deixe seu contato e falamos com você para liberar o acesso de teste.</p>
      </div>
      {state === "sent" ? (
        <div className="flex flex-col items-start gap-3 rounded-2xl border border-emerald-500/40 bg-emerald-500/10 p-8" data-testid="lead-success">
          <CheckCircle2 className="h-8 w-8 text-emerald-400" />
          <p className="font-semibold">Recebemos seu contato!</p>
          <p className="text-sm text-slate-300">Em breve entraremos em contato.</p>
          <Button variant="ghost" onClick={() => setState("idle")} data-testid="lead-new-button">Enviar outro</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="grid gap-4 rounded-2xl border border-slate-700/60 bg-slate-800/40 p-6 sm:grid-cols-2" data-testid="lead-form">
          {FIELDS.map(([k, label, req]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={`lead_${k}`}>{label}{req && " *"}</Label>
              <Input id={`lead_${k}`} required={req} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-11 bg-slate-950" data-testid={`lead-${k}-input`} />
            </div>
          ))}
          <div className="space-y-1.5 sm:col-span-2">
            <Label htmlFor="lead_message">Mensagem</Label>
            <Textarea id="lead_message" rows={3} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="bg-slate-950" data-testid="lead-message-input" />
          </div>
          {error && <p className="text-sm text-rose-300 sm:col-span-2" data-testid="lead-error">{error}</p>}
          <Button type="submit" disabled={state === "sending"} className="h-12 rounded-full font-semibold sm:col-span-2" data-testid="lead-submit-button">
            {state === "sending" && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enviar
          </Button>
        </form>
      )}
    </section>
  );
};
